export default function AuthDivider({ text = "or continue with" }) {
  return (
    <div className="auth-divider" aria-hidden="true">
      <span />
      <p>{text}</p>
      <span />
    </div>
  );
}
